export const PROFILE_LABELS_WIDGET_OPEN_SETTINGS_BUTTON_QA_NAME =
  'openLabelsSettings'
